import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../hooks/use-language";
import { useLanguageSelection } from "../../../hooks/use-language-selection";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const FooterActionPanel = () => {
	const lang = useLanguage();
	const languageSelection = useLanguageSelection();
	const footerTexts = useTranslationsById({ mainSectionName: "footer", language: lang });
	const nextLang = lang === "es" ? "en" : "es";
	const languageLabel =
		lang === "es"
			? footerTexts.getText({ id: "actions.language.es", defaultText: "Español" })
			: footerTexts.getText({ id: "actions.language.en", defaultText: "English" });

	return (
		<div className="footer-action-panel">
			<button
				className="buttonv2 button-secondary focusable-red footer-action-button footer-language-button"
				type="button"
				onClick={() => languageSelection.setLanguage({ lang: nextLang })}
				aria-label={`Cambiar idioma a ${nextLang === "es" ? "Español" : "English"}`}
			>
				<span>{languageLabel}</span>
				<Icon icon="mdi:translate" width={22} />
			</button>
			<Link
				to="/contacto/demo"
				className="buttonv2 button-primary focusable-red footer-action-button"
			>
				{footerTexts.getText({ id: "actions.demo", defaultText: "Pide un demo" })}
			</Link>
			<Link
				to="/contacto/cita"
				className="buttonv2 button-secondary focusable-red footer-action-button"
			>
				{footerTexts.getText({ id: "actions.contact", defaultText: "Contáctanos" })}
			</Link>
			<Link
				to="/admin/login"
				className="buttonv2 button-primary focusable-red footer-action-button"
			>
				{footerTexts.getText({ id: "actions.admin", defaultText: "Admin" })}
			</Link>
		</div>
	);
};
